// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newstooltip[data-v-902de4e8]{margin-left:12px;font-size:15px;background:#6a6a6a}", ""]);
// Exports
module.exports = exports;
